module.exports = __webpack_public_path__ + "static/img/4.895e270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download-new/4.png
// module id = rxDi
// module chunks = 2